export default __webpack_public_path__ + "img/01c1478815478e87a79ea79ca0a82403.svg";